import axios from '../../axios'

// 获取总访问数
export const getVisitData = () => {
    return axios({
        url: '/api/data/wish/large/screen/visit/stat',
        method: 'get'
    })
}

// 获取完善信息数
export const getAddData = () => {
    return axios({
        url: '/api/data/wish/large/screen/user/complete/stat',
        method: 'get'
    })
}

// 获取完善信息数
export const getOrderData = () => {
    return axios({
        url: '/api/data/wish/large/screen/service/order/stat',
        method: 'get'
    })
}

// 获取销售总金额
export const getTotalData = () => {
    return axios({
        url: '/api/data/wish/large/screen/service/order/amount/stat',
        method: 'get'
    })
}

// 获取激活码数量
export const getCodeData = () => {
    return axios({
        url: '/api/user/large/screen/card/code/stat',
        method: 'get'
    })
}

// 获取用户新增图表数据
export const getUserChartData = () => {
    return axios({
        url: '/api/data/wish/large/screen/user/add/days/stat',
        method: 'get'
    })
}

// 获取用户活跃图表数据
export const getUserActiveData = () => {
    return axios({
        url: '/api/data/wish/large/screen/user/active/days/stat',
        method: 'get'
    })
}
// 获取订单图表数据
export const getOrderChartData = (data) => {
    return axios({
        url: '/api/data/wish/large/screen/service/order/days/stat',
        method: 'get',
        data
    })
}

// 获取激活码激活图表数据
export const getCodeActiveChartData = () => {
    return axios({
        url: '/api/data/wish/large/screen/card/code/days/stat',
        method: 'get'
    })
}

// 获取用户统计
export const getUserStat = () => {
    return axios({
        url: '/api/user/large/screen/total/count',
        method: 'get'
    })
}

// 获取激活码统计
export const getCodeStat = () => {
    return axios({
        url: '/api/user/large/screen/card/code/count',
        method: 'get'
    })
}

// 获取销售统计
export const getSaleStat = () => {
    return axios({
        url: '/api/data/wish/large/screen/today/service/order/count',
        method: 'get'
    })
}
// 获取收入统计
export const getIncomeStat = () => {
    return axios({
        url: '/api/data/wish/large/screen/today/income/count',
        method: 'get'
    })
}

export const getUserChannel = (data) => {
    return axios({
        url: '/api/data/wish/large/screen/user/add/tops/stat',
        method: 'get',
        data
    })
}

export const getActiveChannel = (data) => {
    return axios({
        url: '/api/data/wish/large/screen/user/active/tops/stat',
        method: 'get',
        data
    })
}
export const getOnlineChannel = (data) => {
    return axios({
        url: '/api/data/wish/large/screen/service/order/tops/stat',
        method: 'get',
        data
    })
}
export const getCodeChannel = (data) => {
    return axios({
        url: '/api/data/wish/large/screen/card/code/tops/stat',
        method: 'get',
        data
    })
}

export const getFilterData = () => {
    return axios({
        url: '/api/data/wish/partners/type/list',
        method: 'get'
    })
}

// 用户新增弹框统计
export const getFilterdialogData = (data) => {
    return axios({
        url: '/api/data/wish/large/screen/user/add/dialog/stat',
        method: 'get',
        data
    })
}
// 订单弹框统计
export const getavtivelistData = (data) => {
    return axios({
        url: '/api/data/wish/large/screen/user/active/dialog/stat',
        method: 'get',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/wish/data.js